import { useAbility } from '@casl/react';
import React, { memo } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AbilityContext } from '../../casl/AbilityContext';
import ErrorBoundary from '../ErrorBoundary';

function AbilityBasedRoute({ I, a }) {
  const ability = useAbility(AbilityContext);
  const allowed = ability.can(I, a);
  if (allowed) {
    return (
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    );
  }
  return <Navigate to="/" replace />;
}

export default memo(AbilityBasedRoute);
